'use client';

import React from 'react';
import CosaServiceLayout from '@/components/CosaServiceLayout';

const serviceData = {
  slug: 'telemedecine',
  icon: 'fa-solid fa-laptop-medical',
  badge: 'Télémédecine',
  title: 'Télémédecine',
  subtitle: 'Consultations à distance avec nos médecins qualifiés',
  heroImage: '/assets/images/service_telemedicine.png',
  heroAlt: 'Consultation médicale en ligne avec médecin africain via télémédecine COSA',
  accentColor: '#0e5932',
  description: `La télémédecine de COSA permet des consultations médicales à distance grâce à des outils spécialisés et l'expertise de professionnels qualifiés. Accédez à des soins médicaux de qualité sans vous déplacer.`,
  features: [
    { icon: 'fa-solid fa-video', title: 'Consultations Vidéo', description: 'Consultations en direct avec un médecin via vidoéconférence sécurisée.' },
    { icon: 'fa-solid fa-clock', title: 'Disponibilité Étendue', description: 'Consultations disponibles en dehors des heures de bureau pour votre commodité.' },
    { icon: 'fa-solid fa-lock', title: 'Sécurité & Confidentialité', description: 'Plateforme sécurisée garantissant la confidentialité de vos données médicales.' },
    { icon: 'fa-solid fa-prescription-bottle', title: 'Prescriptions Numériques', description: 'Réception de prescriptions électroniques directement sur votre appareil.' },
    { icon: 'fa-solid fa-file-medical-alt', title: 'Dossier Médical Électronique', description: 'Accès à votre historique médical complet et sécurisé.' },
    { icon: 'fa-solid fa-headset', title: 'Support Client 24/7', description: 'Assistance technique et médicale disponible à tout moment.' },
  ],
  process: [
    { step: '01', title: 'Inscription', description: 'Créez votre compte sur la plateforme de télémédecine COSA.' },
    { step: '02', title: 'Prise de Rendez-vous', description: 'Sélectionnez un créneau disponible avec le médecin de votre choix.' },
    { step: '03', title: 'Consultation Vidéo', description: 'Connectez-vous à l\'heure prévue pour votre consultation.' },
    { step: '04', title: 'Suivi & Prescription', description: 'Recevez votre prescription et plan de suivi par voie électronique.' },
  ],
  stats: [
    { value: '500+', label: 'consultations mensuelles' },
    { value: '98%', label: 'satisfaction patient' },
    { value: '15min', label: 'délai moyen d\'attente' },
    { value: '24/7', label: 'disponibilité' },
  ],
};

export default function TelemedecineePage() {
  return <CosaServiceLayout service={serviceData} />;
}
